import { useSelector } from "react-redux";

// Actions
import UploadAction from "@common/redux/actions/UploadAction";
import ConfirmModalAction from "@common/redux/actions/ConfirmModalAction";
import ImageModalAction from "@common/redux/actions/ImageModalAction";
import LoadingAction from "@common/redux/actions/LoadingAction";

// Client
import MediaClient from "@common/api/MediaClient";

// Helpers
import { handleError } from "@common/components/helpers/error";
import { handleSuccess } from "@common/components/helpers/success";
import fetchCctvImages from "@common/components/helpers/fetchCctvImages";

const useUploadedImageList = () => {
  const { incidentId } = useSelector((state) =>
    UploadAction.getStatePath(state),
  );

  const { loadingImages, imageList } = useSelector((state) =>
    UploadAction.getStatePath(state),
  );

  const handleView = (imageId, imageName) => {
    LoadingAction.set(true).then(() => {
      MediaClient.Read(imageId)
        .then((res) => {
          ImageModalAction.open(res.data, imageName);
        })
        .catch((error) => {
          handleError(
            error,
            "Error",
            "There was an error reading the CCTV image",
          );
        })
        .finally(() => LoadingAction.set(false));
    });
  };

  const deleteImage = (imageId) => {
    LoadingAction.set(true).then(() => {
      MediaClient.Delete(imageId)
        .then(() => {
          handleSuccess("CCTV image deleted successfully");
        })
        .catch((error) => {
          handleError(
            error,
            "Error",
            "There was an error deleting the CCTV image",
          );
        })
        .finally(() => {
          fetchCctvImages(incidentId);
          LoadingAction.set(false);
        });
    });
  };

  const handleDelete = (imageId) => {
    ConfirmModalAction.open(
      "Are you sure you want to delete this CCTV image?",
      "Confirm Delete",
      () => deleteImage(imageId),
    );
  };

  return {
    loadingImages,
    imageList,
    handleView,
    handleDelete,
  };
};

export default useUploadedImageList;
